import { render, staticRenderFns } from "./IssuesCreate.vue?vue&type=template&id=3a1c970e"
import script from "./IssuesCreate.vue?vue&type=script&lang=ts"
export * from "./IssuesCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports